import { paramsToQueryString } from "../../Helpers/url";
import DependencyManager from "../../DependencyManager";
import { getLocationId } from "../../Helpers/location";
import { popularDataUrlPath } from "../../Constants/buyEngager";
export function fetchPopularData(props) {
  return function (dispatch, getState, _ref) {
    var get = _ref.get;
    var PanameraConstants = DependencyManager.getDependency('constants');
    var CXE_CLIENT_HEADER = {
      'X-PANAMERA-CLIENT-ID': "web-".concat(PanameraConstants.platform)
    };
    var _getState = getState(),
      selectedLocation = _getState.locations.selectedLocation,
      _getState$popularData = _getState.popularData,
      isError = _getState$popularData.isError,
      isFetching = _getState$popularData.isFetching,
      popularData = _getState$popularData.popularData,
      _getState$api$queryPa = _getState.api.queryParam,
      _getState$api$queryPa2 = _getState$api$queryPa === void 0 ? {} : _getState$api$queryPa,
      _getState$api$queryPa3 = _getState$api$queryPa2.enableMultiLang,
      enableMultiLang = _getState$api$queryPa3 === void 0 ? false : _getState$api$queryPa3,
      _getState$api$queryPa4 = _getState$api$queryPa2.lang,
      lang = _getState$api$queryPa4 === void 0 ? '' : _getState$api$queryPa4;
    var locationId = getLocationId(selectedLocation);
    var params = Object.assign({
      locationId: locationId,
      attribute: props.attribute,
      flow: props.flow,
      category: props.category,
      platform: "web-".concat(PanameraConstants.platform)
    }, enableMultiLang && lang ? {
      lang: lang
    } : {});
    var fullUrl = "".concat(popularDataUrlPath, "?").concat(paramsToQueryString(params));
    if (isError[fullUrl] || isFetching[fullUrl] || popularData[fullUrl]) {
      return Promise.resolve();
    }
    return dispatch(get(popularDataUrlPath, 'POPULAR_DATA', params, CXE_CLIENT_HEADER)).then(function () {
      return;
    });
  };
}
export default fetchPopularData;